import React, { useEffect, useState } from 'react';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { GardenCenter } from './GardenCenter';

export const GardenCenterContainer = ({ ...props }) => {
  const { isCustomerIdentified = false } = useThdCustomer();
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const defaultVariables = {
    isBrandPricingPolicyCompliant: isMounted ? isCustomerIdentified : false,
  };

  return (
    <QueryProvider defaultVariables={defaultVariables} cacheKey="gardenCenter">
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <GardenCenter {...props} />
    </QueryProvider>
  );
};

GardenCenterContainer.propTypes = {};

GardenCenterContainer.defaultProps = {};
